import {IController, ITimeoutService, IWindowService} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";

export class RoutesPrintLoadingSheetCtrl implements IController {
  routes: any;

  public currentDate: any;
  public logoUrl: any;
  public tagsMap: any;
  public routesForPrint: any;

  constructor(private splitService: SplitService, private $window: IWindowService, private $timeout: ITimeoutService, private moment) {
  }

  $onInit() {
    this.currentDate = this.moment().valueOf();
    this.logoUrl = this.splitService.getSiteLogoUrl();
    this.tagsMap = _.mapValues(_.keyBy(_.flatMap(this.routes, 'serviceList'), 'id'), 'tagNames');

    this.routesForPrint = _.chain(this.routes)
      .map((route) => {
        const routeCopy = angular.copy(route);


        const orderedPickupList = _.filter(routeCopy.taskList.reverse(), (rt) => {
          return rt.taskSpec.purpose == "Dropoff";
        }).map(dt => {
          return _.find(routeCopy.taskList, (t) => {
            return t.taskSpec.purpose == "Pickup" && t.serviceId === dt.serviceId
          })
        })

        routeCopy.orderedPickupList = orderedPickupList;
        return routeCopy;
      })
      .value();

  };

  $postLink() {
    this.$timeout(1000).then(() => {
      this.$window.print();
      this.$window.close();
    })
  };

}

angular
  .module('bringoz.admin.routes')
  .component('routesPrintLoadingSheet', {
    bindings: {
      routes: '<',
    },
    template: require('./routes-print-loading-sheet.html').default,
    controller: RoutesPrintLoadingSheetCtrl
  });
